import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '../../components/ui/theme';
import {
  ModalOverlay,
  ModalCard,
  ModalHeader,
  ModalHeaderTitle,
  ModalCloseBtn,
  ModalBody,
  ModalFooter,
  ButtonPrimary,
  ButtonSecondary,
} from '../../components/ui/ModalDA';

/**
 * EpicGoodbyeModal — Modal de confirmation quand un utilisateur Epic SSO ferme
 * la modal checkout sur /land_epic/:id.
 *
 * DA : compose les primitives ModalDA (header violet, croix cerclée, card
 * border-radius 1rem, boutons 0.625rem) — plus de styled-components dupliqués.
 *
 * Hiérarchie d'action (validée par Jonathan) : on veut surtout que l'user PAYE.
 * → "Back to checkout" = bouton VIOLET plein (primaire, mis en avant)
 * → "Continue browsing ▸" = bouton blanc outline (secondaire)
 *
 * z-index 10001 : au-dessus de Checkout + SelectPaymentMethod (9999), qui sont
 * de toute façon masqués pendant l'affichage de cette modal (cf. TileDetails).
 */

// Overlay DA + z-index au-dessus des modals de paiement.
const GoodbyeOverlay = styled(ModalOverlay)`
  z-index: 10001;
`;

// Boutons empilés verticalement : on priorise "Return to Checkout" (violet),
// "Continue browsing" est secondaire et aminci.
const GoodbyeFooter = styled(ModalFooter)`
  flex-direction: column;
  ${media.sm`padding: .75rem 1rem;`}
`;
const FooterButtonPrimary = styled(ButtonPrimary)`
  width: 100%;
`;
const FooterButtonSecondary = styled(ButtonSecondary)`
  width: 100%;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  font-size: 0.78rem;
`;

function EpicGoodbyeModal({ open, onBackToCheckout, onContinueBrowsing }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <GoodbyeOverlay>
      <ModalCard>
        <ModalHeader>
          <ModalHeaderTitle>{t('EpicGoodbyeTitle')}</ModalHeaderTitle>
          <ModalCloseBtn onClick={onBackToCheckout} aria-label={t('EpicGoodbyeBackAria')}>✕</ModalCloseBtn>
        </ModalHeader>
        <ModalBody>
          <p>{t('EpicGoodbyeBody1')}</p>
          <p className="small">{t('EpicGoodbyeBody2')}</p>
        </ModalBody>
        <GoodbyeFooter>
          <FooterButtonSecondary onClick={onContinueBrowsing}>{t('EpicGoodbyeContinueBtn')}</FooterButtonSecondary>
          <FooterButtonPrimary onClick={onBackToCheckout}>{t('EpicGoodbyeReturnBtn')}</FooterButtonPrimary>
        </GoodbyeFooter>
      </ModalCard>
    </GoodbyeOverlay>
  );
}

EpicGoodbyeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onBackToCheckout: PropTypes.func.isRequired,
  onContinueBrowsing: PropTypes.func.isRequired,
};

export default EpicGoodbyeModal;
